/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ActiveGamesInfoBase
 * auto generated base class for the model ActiveGamesInfoModel.
 */
export const ActiveGamesInfoModelBase = ModelBase.named('ActiveGamesInfo')
  .props({
    __typename: types.optional(types.literal('ActiveGamesInfo'), 'ActiveGamesInfo'),
    activeBotsCount: types.union(types.undefined, types.number),
    activeGamesCount: types.union(types.undefined, types.number),
    activeGamesWithOnlyBotsCount: types.union(types.undefined, types.number),
    activeUsersCount: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ActiveGamesInfoModelSelector extends QueryBuilder {
  get activeBotsCount() {
    return this.__attr('activeBotsCount')
  }
  get activeGamesCount() {
    return this.__attr('activeGamesCount')
  }
  get activeGamesWithOnlyBotsCount() {
    return this.__attr('activeGamesWithOnlyBotsCount')
  }
  get activeUsersCount() {
    return this.__attr('activeUsersCount')
  }
}
export function selectFromActiveGamesInfo() {
  return new ActiveGamesInfoModelSelector()
}

export const activeGamesInfoModelPrimitives =
  selectFromActiveGamesInfo().activeBotsCount.activeGamesCount.activeGamesWithOnlyBotsCount.activeUsersCount
